import { Paper } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, purpleMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const LiveMapRideFilterDropdownWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-ride-filter-dropdown",
  },
)`
  position: relative;
  display: inline-flex;
  align-items: center;

  .live-map-ride-filter-popper {
    z-index: ${ScreenDepth.FLOATING_MENU};
  }

  .live-map-ride-filter-trigger {
    width: 32px;
    min-width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid ${greyMui._300};
    border-radius: 4px;
    background-color: ${rydeColors.white};
    color: ${rydeColors.black};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    &:hover {
      background-color: ${rydeColors.focusedOption};
    }

    svg {
      margin: 0;
      flex-shrink: 0;
    }

    .live-map-ride-filter-icon {
      width: 16px;
      height: 13px;
      display: block;
    }

    .live-map-ride-filter-icon--muted {
      color: ${greyMui._400};
    }

    .live-map-ride-filter-icon--active {
      color: ${purpleMui._600};
    }
  }
`;

/** Popover menu styles live on Paper so they still apply when Popper uses a portal (mobile). */
export const LiveMapRideFilterDropdownMenuStyled = styled(
  Paper,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-ride-filter-dropdown-menu",
  className: "live-map-ride-filter-dropdown-menu",
})`
  .live-map-ride-filter-dropdown-item {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 260px;
    padding-block: 10px;
    padding-inline: 12px;
  }

  .live-map-ride-filter-dropdown-item__label {
    font-size: 13px;
    line-height: 1.3;
    color: ${rydeColors.black};
  }

  .live-map-ride-filter-preview {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${greyMui._300};
    border-radius: 4px;
    background-color: ${rydeColors.white};
    line-height: 0;

    svg {
      margin: 0;
    }
  }

  .live-map-ride-filter-preview__image {
    width: 16px;
    height: 13px;
    display: block;
    margin: 0;
  }

  .live-map-ride-filter-preview .live-map-ride-filter-icon--muted {
    color: ${greyMui._400};
  }

  .live-map-ride-filter-preview .live-map-ride-filter-icon--active {
    color: ${purpleMui._600};
  }
`;
